import React, { Component } from 'react';
import styles from '../../Css/ShootDetails/ShootDetails.module.css';
import PropTypes from 'prop-types';

// redux
import {connect} from 'react-redux'

class HotSpotBriefView extends Component {

    render() {
        return (
            <div className={[styles['shoot-card'],styles['grid-card'],'col-md-12'].join(' ')}>
                <div className={[styles['right-title'],'row'].join(' ')}>
                    <div className={[styles['project-title'],'col-md-12'].join(' ')}>
                        <h4> 
                            {           
                                this.props.skuName.length ? `${this.props.skuName}` : "SKU Name"
                            }
                        </h4>
                        
                        <ul>
                            <li className={[styles['second']]}>
                                <span> 
                                    {
                                        this.props.isPaid ? "Paid" : "Unpaid"
                                    } 
                                </span>
                            </li>
                            <li className={[styles['third']]}>
                                <span>
                                    {
                                        this.props.is360 ? "360" : "not 360"
                                    }
                                </span>
                            </li>
                        </ul>
                        <div style={{textAlign:'center'}}>
                            <img 
                                src={ 
                                    (this.props.hotSpotId && this.props.syncHotSpotTitleDescURL.has(this.props.hotSpotId) && this.props.syncHotSpotTitleDescURL.get(this.props.hotSpotId).closeUpURL) 
                                    ? this.props.syncHotSpotTitleDescURL.get(this.props.hotSpotId).closeUpURL : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/static/app-dashboard/no-preview-image.png`
                                } 
                                alt=""
                                className={[styles['preview-image']]}
                            />
                        </div>
                    </div>
                    
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps)=>{
    return{
        hotSpotMapObj : state.hotspotReducer.hotSpotMapObj,
        currentImageObj : state.hotspotReducer.currentImageObj,
        hotSpotId : state.hotspotReducer.hotSpotId,
        syncHotSpotTitleDescURL : state.hotspotReducer.syncHotSpotTitleDescURL,
    }
}

// proptype checking
HotSpotBriefView.propTypes = {
    skuName: PropTypes.string.isRequired,
    isPaid: PropTypes.bool.isRequired,
    is360: PropTypes.bool.isRequired,
    //currentImageObj: PropTypes.object.isRequired // imported from redux
    imgObj: PropTypes.object
}



export default connect(mapStateToProps, null)(HotSpotBriefView)
